import TemporaryCampaignApi from '@/api/TemporaryCampaign'
import {
  CompoundCampaignModel,
  IncompleteCampaignModel,
} from './CompoundCampaign'

export class TemporaryCampaignRepository {
  static async getIncomplete() {
    try {
      const result = await TemporaryCampaignApi.getIncomplete()
      return result.items.map(IncompleteCampaignModel.assign)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async create(data) {
    try {
      const result = await TemporaryCampaignApi.create(data)
      return new CompoundCampaignModel(result.item)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async update(id, data) {
    try {
      const result = await TemporaryCampaignApi.update(id, data)
      return new CompoundCampaignModel(result.item)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async setComplete(campaignId) {
    try {
      return await TemporaryCampaignApi.setComplete(campaignId)
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}
